import React from 'react'
import PropTypes from 'prop-types'

import MuiSelect from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

export const ParticipantFilter = ({
  view,
  filteredItemsName,
  showBoth,
  participantsQueries,
  selectedParticipantId,
  setSelectedParticipantId
}) => {
  return (
    <div className={`form-field app-form__select w-full`}>
      {(!view || view === 'index')
        ? <MuiSelect
          className='select'
          value={selectedParticipantId || null}
          onChange={(event) => setSelectedParticipantId(event.target.value)}
        >
          {participantsQueries.map((participantQuery) => (
            <MenuItem key={participantQuery.participant.id} value={participantQuery.participant.id}>
              View {participantQuery.participant.preferredName}'s {filteredItemsName}
            </MenuItem>
          ))}
          {showBoth
            ? <MenuItem value={'both'}>View joint {filteredItemsName}</MenuItem>
            : null}
        </MuiSelect>
        :
        <div className='text-right'>
          <span>
            {"Viewing for: "}
            <strong>
              {participantsQueries.find((participantQuery) => participantQuery.participant.id === selectedParticipantId).participant.name}
            </strong>
          </span>
        </div>
      }
    </div>
  )
}

ParticipantFilter.propTypes = {
  /* If true, add a "both" option to the select */
  both: PropTypes.bool,

  /* The name of the items being filtered */
  filteredItemsName: PropTypes.string.isRequired,

  /* Array of participant queries */
  participantsQueries: PropTypes.arrayOf(PropTypes.shape({
    participant: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  })).isRequired,

  /* The id of the selected participant */
  selectedParticipantId: PropTypes.string,

  /* Function to set the selected participant id */
  setSelectedParticipantId: PropTypes.func.isRequired,

  /* The current view of the container the filter is rendered in
   * If the view is not index, the filter is not shown - only the name of
   * the current participant is shown
   **/
  view: PropTypes.oneOf(['index', 'create', 'edit', 'show', 'destroy'])
}
